export default __webpack_public_path__ + "assets/menu-management.dcd1369c.svg";